import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    TgCardModule,
    TgCheckboxModule,
    TgGridModule,
    TgLists2Module,
    TgRadioModule,
    TgSvgModule
} from '@trademe/tangram';
import { MotorsIllustrationBoatModule } from '../../components/motors-illustration-boat/motors-illustration-boat.module';
import { MotorsListingDetailsHeaderSectionComponent } from './motors-listing-details-header-section.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        TgSvgModule,
        TgRadioModule,
        TgCardModule,
        TgCheckboxModule,
        TgLists2Module,
        MotorsIllustrationBoatModule
    ],
    declarations: [MotorsListingDetailsHeaderSectionComponent],
    exports: [MotorsListingDetailsHeaderSectionComponent]
})
export class MotorsListingDetailsHeaderSectionModule {}
